var map = {
	"./ava_logo.svg": 9786,
	"./galeria_logo.svg": 5213,
	"./jamh_logo.svg": 7372,
	"./kbmo_logo.svg": 4085,
	"./ktkh_logo.svg": 9132,
	"./pmh_logo.svg": 3129,
	"./szimh_logo.svg": 6217
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2628;